var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"custom-dropdown dropdown b-dropdown",class:{
    'btn-group': !_vm.block,
    'dropup': _vm.dropup,
    'show': _vm.showMenu,
  },attrs:{"id":_vm.id + '___FB_dropdown_outer_'},on:{"focusout":_vm.handleFocusOut,"blur":_vm.handleBlur}},[_c('button',{staticClass:"btn dropdown-toggle",class:[
      _vm.toggleClass, 
      'btn-' + _vm.variant, 
      {
        'dropdown-toggle-no-caret': _vm.noCaret,
        'btn-block': _vm.block,
      },
    ],attrs:{"disabled":_vm.disabled},on:{"click":_vm.handleToggle}},[_vm._t("button-content")],2),_c('ul',{ref:"menu",staticClass:"dropdown-menu tw-z-50",class:[
      _vm.menuClass, 
      _vm.showMenuStyle, 
      'dropdown-menu-' + _vm.variant, 
      {
        'dropdown-menu-left': !_vm.right,
        'dropdown-menu-right': _vm.right,
        'tw-absolute': _vm.right,
        'show': _vm.showMenu,
      },
    ],attrs:{"role":"menu"},on:{"click":_vm.handleHideMenu}},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }